import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { accountSelector } from '../store/shared/accountSlice';
import {
  LogSearchApiRequest,
  useGetLogsQuery,
} from '../../Admin/AdminLogs/apiSlice';
import toISOStringWithTimezone from '../utils/toISOStringWithTimezone';
import { setCurrentLog, logSelector } from '../store/shared/logListSlice';

export default function useGetLogs(
  search: LogSearchApiRequest | null = null,
  initialRequest: boolean = true,
) {
  const { currentAccountId } = useSelector(accountSelector);
  const [hasLoaded, setHasLoaded] = useState<boolean>(false);
  const cloneSearch: LogSearchApiRequest = { ...search };
  const logs = useSelector(logSelector);
  const dispatch = useDispatch();

  if (search?.startDate) {
    // @ts-ignore
    cloneSearch.startDate = toISOStringWithTimezone(
      new Date(decodeURI(search.startDate)),
      'start',
    )
      .replace(new RegExp(/\+/, 'g'), '%2B')
      .replace(new RegExp(/:/, 'g'), '%3A');
    cloneSearch.endDate = toISOStringWithTimezone(
      new Date(decodeURI(search.startDate)),
      'end',
    )
      .replace(new RegExp(/\+/, 'g'), '%2B')
      .replace(new RegExp(/:/, 'g'), '%3A');
  }

  const { data: logsData, isLoading } = useGetLogsQuery(
    {
      accountId: currentAccountId,
      search: {
        ...cloneSearch,
        continuationToken: initialRequest ? '' : logs.continuationToken,
      },
    },
    // skip query when hasLoaded is true
    {
      refetchOnMountOrArgChange: true,
      skip: initialRequest ? false : hasLoaded,
    },
  );

  useEffect(() => {
    if (logsData) {
      if (logsData?.logs) {
        let token = '';
        if (logsData.logs.continuationToken) {
          token = logsData.logs.continuationToken;
        }
        if (logsData.logs.items) {
          dispatch(
            setCurrentLog({
              list: initialRequest
                ? logsData.logs.items
                : [...logs.list, ...logsData.logs.items],
              continuationToken: token,
            }),
          );
        }
        setHasLoaded(true);
      }
    }
  }, [logsData]);

  const handleLoadMore = () => {
    // set hasLoaded to false when clicking load more
    setHasLoaded(false);
  };

  return {
    storedData: logs?.list,
    isLoading,
    hasMore: logs?.continuationToken?.length > 0,
    handleLoadMore,
  };
}
